import React from 'react';
import { getRecommendationsByCategory } from '../../../utils/assessmentResults/calculations';

/**
 * Category statistics component
 */
export const CategoryStats = ({ recommendations }) => {
  const categories = [
    {
      key: 'low_cost',
      label: 'Low-cost Measures',
      subtitle: '< 1 year payback',
      color: 'green'
    },
    {
      key: 'medium_cost',
      label: 'Medium-cost Measures',
      subtitle: '1-3 years payback',
      color: 'yellow'
    },
    {
      key: 'high_cost',
      label: 'High-impact Measures',
      subtitle: '3-5 years payback',
      color: 'red'
    }
  ];

  const colorClasses = {
    green: {
      bg: 'bg-green-50 dark:bg-green-900/30',
      valueColor: 'text-green-600 dark:text-green-400',
      labelColor: 'text-green-800 dark:text-green-300',
      subtitleColor: 'text-green-600 dark:text-green-400'
    },
    yellow: {
      bg: 'bg-yellow-50 dark:bg-yellow-900/30',
      valueColor: 'text-yellow-600 dark:text-yellow-400',
      labelColor: 'text-yellow-800 dark:text-yellow-300',
      subtitleColor: 'text-yellow-600 dark:text-yellow-400'
    },
    red: {
      bg: 'bg-red-50 dark:bg-red-900/30',
      valueColor: 'text-red-600 dark:text-red-400',
      labelColor: 'text-red-800 dark:text-red-300',
      subtitleColor: 'text-red-600 dark:text-red-400'
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {categories.map((category) => {
        const count = getRecommendationsByCategory(recommendations, category.key).length;
        const classes = colorClasses[category.color] || colorClasses.green;

        return (
          <div key={category.key} className={`text-center p-4 ${classes.bg} rounded-lg`}>
            <div className={`text-2xl font-bold ${classes.valueColor} mb-2`}>
              {count}
            </div>
            <div className={`font-medium ${classes.labelColor}`}>{category.label}</div>
            <div className={`text-sm ${classes.subtitleColor} mt-1`}>{category.subtitle}</div>
          </div>
        );
      })}
    </div>
  );
};
